import { useState } from 'react';
import axios from 'axios';
import { useI18n } from '@/i18n';
import { CONSENT_API } from './useBookingConsent';
import { ConsentDocument } from './ConsentDocument';
import './booking.css';

export const ConsentHistory=({scope,eventId,bookingId,bookingKey,id})=>{
  const {tx,lang}=useI18n();
  const [rows,setRows]=useState(null),[selected,setSelected]=useState(null),[error,setError]=useState(''),[busy,setBusy]=useState(false);
  if(!bookingId||!eventId)return null;
  const load=async()=>{
    setBusy(true);setError('');
    try{const r=await axios.get(`${CONSENT_API}/records/${scope}/${encodeURIComponent(eventId)}/${bookingId}`,
      {withCredentials:true,headers:bookingKey?{'X-Booking-Key':bookingKey}:{}});setRows(r.data.items);}
    catch{setError('Consent records are private. Please use the original booking browser or contact the organiser.');}
    finally{setBusy(false);}
  };
  return <section className="booking-consent-history" data-testid={`${id}-history`}>
    <button type="button" data-testid={`${id}-history-load`} onClick={load} disabled={busy}>{tx('My photography consent records')}</button>
    {error&&<p role="alert" data-testid={`${id}-history-error`}>{tx('Consent records are private. Please use the original booking browser or contact the organiser.')}</p>}
    {rows?.map(row=><div key={row.id} data-testid={`${id}-record-${row.id}`}>
      <span>{new Date(row.accepted_at).toLocaleString(lang)} · {row.language.toUpperCase()} · {row.version}</span>
      <strong data-testid={`${id}-record-status-${row.id}`}>{row.status==='accepted'?tx('Consent recorded'):row.status==='withdrawal_requested'?tx('Withdrawal requested'):tx('Withdrawal processed')}</strong>
      <button type="button" data-testid={`${id}-record-view-${row.id}`} onClick={()=>setSelected(row)}>{tx('View consent document')}</button>
      {row.actions.map(a=><p key={a.id} data-testid={`${id}-record-action-${a.id}`}>{a.action==='withdrawal_requested'?tx('Withdrawal requested'):tx('Withdrawal processed')} · {new Date(a.created_at).toLocaleString(lang)}</p>)}
    </div>)}
    {selected&&<ConsentDocument id={`${id}-saved`} document={selected.snapshot} open={Boolean(selected)} onOpenChange={v=>{if(!v)setSelected(null);}}/>}
  </section>;
};